var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "show h-8 w-8 bg-transparent",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5244 15.1031H12.0037V11.1577C12.0037 10.217 11.9872 9.00669 10.6933 9.00669C9.38148 9.00669 9.18126 10.0319 9.18126 11.0906V15.1031H6.66289V6.9903H9.07973V8.09955H9.1142C9.45042 7.46158 10.2735 6.78913 11.5003 6.78913C14.0527 6.78913 14.5244 8.46883 14.5244 10.6538V15.1031ZM3.81964 5.88199C3.00978 5.88199 2.35716 5.22702 2.35716 4.41952C2.35716 3.61249 3.00978 2.95752 3.81964 2.95752C4.6262 2.95752 5.28117 3.61249 5.28117 4.41952C5.28117 5.22702 4.6262 5.88199 3.81964 5.88199ZM2.55739 15.1031H5.08095V6.9903H2.55739V15.1031ZM15.7801 0.617188H1.29231C0.600508 0.617188 0.0380859 1.16591 0.0380859 1.84308V16.3904C0.0380859 17.0675 0.600508 17.6172 1.29231 17.6172H15.7801C16.4738 17.6172 17.0376 17.0675 17.0376 16.3904V1.84308C17.0376 1.16591 16.4738 0.617188 15.7801 0.617188Z",
    fill: "#241C15"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linkedInLogo.05818341e9e9dee2fc9db80f24961c16.svg";
export { ForwardRef as ReactComponent };